import React from 'react';

const brands = [
    'ROLEX', 'PATEK PHILIPPE', 'AUDEMARS PIGUET', 'OMEGA', 'CARTIER', 'RICHARD MILLE', 'VANCHERON CONSTANTIN'
];

const Brands = () => {
    return (
        <section className="py-12 bg-luxury-cream border-y border-luxury-gold/10 overflow-hidden">
            <div className="container mx-auto px-4 mb-8 text-center">
                <p className="text-sm uppercase tracking-[0.3em] text-gray-500">Trusted by Collectors of</p>
            </div>

            <div className="relative flex overflow-x-hidden group">
                <div className="animate-marquee whitespace-nowrap flex space-x-16 items-center">
                    {/* First set of brands */}
                    {brands.map((brand, index) => (
                        <span key={index} className="text-2xl md:text-3xl font-serif font-bold text-luxury-gold/40 hover:text-luxury-gold transition-colors cursor-default">
                            {brand}
                        </span>
                    ))}
                    {/* Duplicate set for seamless loop */}
                    {brands.map((brand, index) => (
                        <span key={`dup-${index}`} className="text-2xl md:text-3xl font-serif font-bold text-luxury-gold/40 hover:text-luxury-gold transition-colors cursor-default">
                            {brand}
                        </span>
                    ))}
                    {/* Triplicate set for wide screens */}
                    {brands.map((brand, index) => (
                        <span key={`trip-${index}`} className="text-2xl md:text-3xl font-serif font-bold text-luxury-gold/40 hover:text-luxury-gold transition-colors cursor-default">
                            {brand}
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Brands;
